import { render, staticRenderFns } from "./CalculationTotal.vue?vue&type=template&id=17a4bccc&"
import script from "./CalculationTotal.vue?vue&type=script&lang=ts&"
export * from "./CalculationTotal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports